import { render, staticRenderFns } from "./addFilter.vue?vue&type=template&id=467e96d7&scoped=true&"
import script from "./addFilter.vue?vue&type=script&lang=js&"
export * from "./addFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e96d7",
  null
  
)

export default component.exports